import React from 'react';
import clsx from 'clsx';
import { bool } from 'prop-types';

import FormControlLabel from '@material-ui/core/FormControlLabel';
import CircularProgress from '@material-ui/core/CircularProgress';

import SwitchBase from './SwitchBase';

import defaultClasses from './Switch.module.css';


const Switch = ({ error, label, isLoading, ...props }) => {

    if (isLoading) {
        return (
            <React.Fragment>
                <CircularProgress
                    className={defaultClasses.cellProgress}
                    size={20}
                />
            </React.Fragment>
        );
    }

    return (
        <FormControlLabel
            classes={{
                label: clsx(
                    defaultClasses.label,
                    {
                        [defaultClasses.labelError]: error
                    }
                )
            }}
            control={<SwitchBase disableRipple {...props} />}
            label={label}
        />
    );
};

Switch.defaultProps = {
    isLoading: false
};

Switch.propTypes = {
    isLoading: bool
};

export default Switch;
